import CategoryCard from "./CategoryCard";

const categories = [
  {
    title: "Books",
    description:
      "Thought-provoking books for curious minds and intentional living.",
    image: "/images/books-category.jpg",
    link: "/shop/books",
  },

  {
    title: "Coffee",
    description:
      "Freshly roasted beans sourced from ethical farms around the world.",
    image: "/images/coffee-category.jpg",
    link: "/shop/coffee",
  },

  {
    title: "Apparel",
    description:
      "Comfortable essentials crafted with timeless simplicity.",
    image: "/images/apparel-category.jpg",
    link: "/shop/apparel",
  },

  {
    title: "Greens",
    description:
      "Indoor plants and botanical accessories that bring life home.",
    image: "/images/plants-category.jpg",
    link: "/shop/greens",
  },
];

export default function Categories() {
  return (
    <section className="bg-[#FAFCF9] py-24">

      <div className="mx-auto max-w-7xl px-6">

        {/* Heading */}

        <div className="mb-16 text-center">

          <span className="text-sm uppercase tracking-[4px] text-[#6B8E5F]">
            Shop by Category
          </span>

          <h2 className="mt-4 text-4xl font-semibold text-[#1F2937] md:text-5xl">
            Curated Collections
          </h2>

          <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-600">
            Explore thoughtfully selected collections designed to inspire
            slower mornings, meaningful reading, mindful rituals, and
            beautiful spaces.
          </p>

        </div>

        {/* Grid */}

        <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-4">

          {categories.map((category) => (
            <CategoryCard
              key={category.title}
              {...category}
            />
          ))}

        </div>

      </div>

    </section>
  );
}